import { GoogleService } from '../../../services/google.service';
import { UtilsService } from '../../../services/utils.service';
import { LocationType } from '../../../types/location.type';
import {
  Component,
  ElementRef,
  Input,
  ViewChild,
  OnChanges,
} from '@angular/core';

@Component({
  selector: 'app-google-map',
  templateUrl: './google-map.component.html',
  styleUrls: ['./google-map.component.scss'],
})
export class GoogleMapComponent implements OnChanges {
  @ViewChild('map', { static: true }) mapRef: ElementRef;
  @Input() locationString: string | LocationType;

  public location: LocationType | undefined = undefined;

  ngOnChanges(): void {
    this.location = UtilsService.parseLocation(this.locationString);

    const latLng = {
      lat: Number(this.location?.lat ?? 0),
      lng: Number(this.location?.lng ?? 0),
    };

    GoogleService.getMaps().then((maps) => {
      const map = new maps.Map(this.mapRef.nativeElement as HTMLElement, {
        center: latLng,
        zoom: 12,
        mapId: UtilsService.getUniqueId(),
      });

      GoogleService.getMarker().then((marker) => {
        new marker.AdvancedMarkerElement({
          position: latLng,
          map,
        });
      });
    });
  }
}
